export const calcDate = (date1, date2) => {
  let date3 = date2 - date1;

  let days = Math.floor(date3 / (24 * 3600 * 1000))

  let leave1 = date3 % (24 * 3600 * 1000) //计算天数后剩余的毫秒数
  let hours = Math.floor(leave1 / (3600 * 1000))

  let leave2 = leave1 % (3600 * 1000) //计算小时数后剩余的毫秒数
  let minutes = Math.floor(leave2 / (60 * 1000))

  let leave3 = leave2 % (60 * 1000) //计算分钟数后剩余的毫秒数
  let seconds = Math.round(date3 / 1000)
  return {
    leave1,
    leave2,
    leave3,
    days: days,
    hours: hours,
    minutes: minutes,
    seconds: seconds,
  }
}

/**
 * 日期格式化
 */
export function dateFormat(date, format) {
  format = format || 'yyyy-MM-dd hh:mm:ss';
  if (date !== 'Invalid Date') {
    let o = {
      "M+": date.getMonth() + 1, //month
      "d+": date.getDate(), //day
      "h+": date.getHours(), //hour
      "m+": date.getMinutes(), //minute
      "s+": date.getSeconds(), //second
      "q+": Math.floor((date.getMonth() + 3) / 3), //quarter
      "S": date.getMilliseconds() //millisecond
    }
    if (/(y+)/.test(format)) format = format.replace(RegExp.$1,
      (date.getFullYear() + "").substr(4 - RegExp.$1.length));
    for (let k in o)
      if (new RegExp("(" + k + ")").test(format))
        format = format.replace(RegExp.$1,
          RegExp.$1.length === 1 ? o[k] :
            ("00" + o[k]).substr(("" + o[k]).length));
    return format;
  }
  return '';

}

// 补零函数
export function doHandleZero(zero) {
  let date = zero;
  if (zero.toString().length == 1) {
      date = "0" + zero;
  }
  return date;
}

/**
 * 获取当前年月日
 * let dataNow = getDateNow(0); // 当前日期
 * let lastWeek = getDateNow(-7); // 上周同天
 * */
export function getDateNow(val) {
    let myDate = new Date();
    let tYear = myDate.getFullYear()
    let tMonth = myDate.getMonth()
    let tDay = myDate.getDate()+val
    tMonth = doHandleZero(tMonth + 1)
    tDay = doHandleZero(tDay)

    return tYear + '' + tMonth + '' + tDay
}

/**
  * 判断当前日期为当月第几周
  * a = d = 当前日期
  * b = 6 - w = 当前周的还有几天过完(不算今天)
  * a + b 的和在除以7 就是当天是当前月份的第几周
**/
export function getWeek(date) {
  //date是需要计算的日期。通过new Date() 方法获取时间戳
  let theDate = new Date(date);
  //通过getDay()方法获取到date是星期几
  let week = theDate.getDay();
  //通过getDate()方法返回date是几日
  let day = theDate.getDate();

  if( week == 0){
  　　week = 7;
  }
  return Math.ceil((day + 6 - week) / 7);
};

//获得某月的最后一天
export function getLastDay(year,month) {
  let new_year = year;    //取当前的年份
  let new_month = month++;//取下一个月的第一天，方便计算（最后一天不固定）
  if(month>12) {
   new_month -=12;        //月份减
   new_year++;            //年份增
  }
  let new_date = new Date(new_year,new_month,1);                //取当年当月中的第一天
  return (new Date(new_date.getTime()-1000*60*60*24)).getDate();//获取当月最后一天日期
}

 /**
 * 计算两个日期之间的天数
 * @param dateString1  开始日期 yyyy-MM-dd
 * @param dateString2  结束日期 yyyy-MM-dd
 * @returns {number} 如果日期相同 返回一天 开始日期大于结束日期，返回0
 */
export function  getDaysBetween(dateString1,dateString2){
  let  startDate = Date.parse(dateString1);
  let  endDate = Date.parse(dateString2);
  if (startDate>endDate){
    return 0;
  }
  if (startDate==endDate){
    return 1;
  }
  let days=(endDate - startDate)/(1*24*60*60*1000);
  return  days;
}

//获取上个月日期
export function getLastMonth(){
  let date = new Date; 
  let year = date.getFullYear();
  let month = date.getMonth();
  if(month == 0){
       year = year -1;
       month = 12; 
  }
  if(month < 10) {
    month = `0${month}`
  }
  return year+"-"+month;
}

/**
 * JS获取当前年月，获取N个月前/后年月
 * @param n n为正数为n月后，n为负数为n月前
 */
export function getSpecifiedYearMonth(n){
  console.log("n:"+n);
  // JS获取当前年月，获取N个月前/后年月
  let date = new Date();
  let nowYear = date.getFullYear();//获取当前年份
  // let nowMonth = date.getMonth()+1;//获取当前月份
  let nMonth = date.getMonth()+1+n; //n为正数则为n月后，n为负数则为n月前 
  let nYear = ""
  if(n>0){
    if(nMonth<=12){
      nYear = nowYear;
    }else{ 
      nYear = nowYear +  parseInt((nMonth-1) / 12);
        nMonth = Math.abs(nMonth%12) == 0 ? 12 : parseInt(Math.abs(nMonth%12));
    }
  }else{
    if(nMonth>0){
      nYear = nowYear;
    }else{
      nYear = nowYear -   parseInt(Math.abs((nMonth  / 12) - 1));
      nMonth = 12 - parseInt(Math.abs(nMonth%12));
    }
  }
  // let nowYearMonth = nowYear *100 + nowMonth ; //当前年月
  let nYearMonth = (nYear *100 + nMonth).toString(); //n月前/后年月
  return nYearMonth.substr(0,4) + '-' + nYearMonth.substr(4,5)
}


// 将时间戳转换成日期格式
export function timestampToTime(timestamp) {
  let date = new Date(timestamp * 1000);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
  let Y = date.getFullYear() + '-';
  let M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
  let D = date.getDate() + ' ';
  let h = date.getHours() + ':';
  let m = date.getMinutes() + ':';
  let s = date.getSeconds();
  return Y+M+D+h+m+s;
}

// 获取两个日期之间所有的日期（YYYY-MM-DD）
export function getBetweenDateStr(start,end){
  let result = [];
  let beginDay = start.split("-");
  let endDay = end.split("-");
  let diffDay = new Date();
  let dateList = new Array;
  let i = 0;
  diffDay.setDate(beginDay[2]);
  diffDay.setMonth(beginDay[1]-1);
  diffDay.setFullYear(beginDay[0]);
  result.push(start);
  while(i == 0){
      let countDay = diffDay.getTime() + 24 * 60 * 60 * 1000;
      diffDay.setTime(countDay);
      dateList[2] = diffDay.getDate();
      dateList[1] = diffDay.getMonth() + 1;
      dateList[0] = diffDay.getFullYear();
      if(String(dateList[1]).length == 1){dateList[1] = "0"+dateList[1]};
      if(String(dateList[2]).length == 1){dateList[2] = "0"+dateList[2]};
      result.push(dateList[0]+"-"+dateList[1]+"-"+dateList[2]);
      if(dateList[0] == endDay[0] && dateList[1] == endDay[1] && dateList[2] == endDay[2]){ i = 1;
      }
  };
  return result;
};


// WEBPACK FOOTER //
// ./src/util/date.js